import React from "react";
import "./Why_Choose_Us.css";
import { IDS } from "../../../utils/common";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { getwhychooseus } from "../../../utils/apis/common/Common";

function Why_Choose_Us() {
  const cards = [
    {
      img: "/assets/images/home/why-choose-us/professional.png",
      title: "Experienced Solar Professionals",
      text:
        "Years of hands-on experience delivering efficient & reliable solar installations.",
    },
    {
      img: "/assets/images/home/why-choose-us/screw.png",
      title: "Customized Solar Solutions",
      text:
        "Tailor-made systems designed to match your energy needs and budget.",
    },
    {
      img: "/assets/images/home/why-choose-us/component.png",
      title: "High-Quality Components",
      text:
        "We use trusted, certified solar panels and inverters for long-lasting performance.",
    },
    {
      img: "/assets/images/home/why-choose-us/mechanic.png",
      title: "End-to-End Service",
      text:
        "Complete support from consultation to installation and maintenance.",
    },
    {
      img: "/assets/images/home/why-choose-us/save-money.png",
      title: "Maximum Savings Guaranteed",
      text:
        "Optimized system design to help you reduce electricity bills significantly.",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [whychooseus, setWhyChooseUs] = useState([]);

  const getWhyChoose = async () => {
    const res = await getwhychooseus();
    if (res?.success) {
      setWhyChooseUs(res.data);
    }
  };
  useEffect(() => {
    getWhyChoose();
  }, []);

  return (
    <section className="why_choose_us py-5">
      <div className="container text-center">
        <h2 className="head_text mb-3">
          Why choose us for your solar installation
        </h2>

        <p className="text mb-5">
          We combine expertise, quality, and end-to-end support to deliver solar
          solutions you can rely on.
        </p>

        <div className="row g-4 justify-content-center">
          {whychooseus.map((card, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-2 col-sm-6 custom_col">
              <div className="why_card h-100 p-4 text-start">
                <div className="icon mb-3">
                  <img
                    src={IDS?.IMG_URL + card?.image}
                    // src={card.img}
                    alt={card.name}
                    className="why_icon_img"
                  />
                </div>
                <h5>{card.name}</h5>
                <p>{htmlToReactParser.parse(card.description)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Why_Choose_Us;
